import identity from "lodash/fp/identity";

class StatsPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default StatsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/stats/stats.transforms.js